import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllHistory = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/history');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
